import React from 'react';
import './trusted.css';
import trust from "../Assets/trust.png"

function TrustedByHospitals() {
  return (
    <div className="trusted-container"  style={{ backgroundImage: `url(${trust})`}}>
      <div className="trusted-overlay">
        <div className="trusted-left">
          <h2>Trusted by<br/>Hospitals</h2>
        </div>
      </div>
    </div>
  );
}

export default TrustedByHospitals;
